import React, { useState, useEffect } from "react";
import "./style/debtDetails.css";
import { DebtPayOffDetails } from "./DebtDetailsComponets/DebtPayOffDetails";
import { DebtPayOffProgress } from "./DebtDetailsComponets/DebtPayOffProgress";
import { DebtTransactionList } from "./DebtDetailsComponets/DebtTransactionList";
import { DetailChart } from "./DebtDetailsComponets/DetailChart";
import { DebtPayOffListing } from "./DebtDetailsComponets/DebtPayOffListing";
import { DebtAmortization } from "./DebtDetailsComponets/DebtAmortization";
import * as Style from "../../../newComponents/styledComponents/styles/ModalStyle";
import { Modal, Select, DatePicker } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import { MODULE_API } from "../../../apis";

import moment from "moment";

const { Option } = Select;

export const DebtDetails = () => {
  const [showModal, setshowModal] = useState(false);
  const [formData, setFormData] = useState({});

  const [loading, setLoading] = useState(false);

  const [duration, setDuration] = useState(null);
  const [amortizationData, setAmortizationData] = useState(null);
  const [principalPaidSum, setPrincipalPaidSum] = useState(null);
  const [totalRemainingBalance, setTotalRemainingBalance] = useState(null);
  const [totalPaid, setTotalPaid] = useState(null);
  const [transactionRecords, setTransactionRecords] = useState([]);
  const history = useHistory();

  const location = useLocation();
  // console.log("params location", location.details);

  const clickedData = location.details && location.details;

  const getLiabilitesList = async () => {
    try {
      (async () => {
        setLoading(true);
        if (clickedData === undefined || clickedData.id === undefined) {
          history.push("/debtPayOff");
        } else {
          let datares = await MODULE_API.getTransactionsData(clickedData.id);
          setLoading(false);

          if (datares && datares.data && datares.data.rows) {
            setTransactionRecords(datares.data.rows);
          }
        }
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("calling api");
    getLiabilitesList();
  }, []);

  useEffect(() => {
    if (clickedData) {
      const maturityDate = moment(clickedData["Maturity Date"]);
      const todayDate = moment();
      const diffDuration = moment.duration(maturityDate.diff(todayDate));
      const years = diffDuration.years();
      const months = diffDuration.months();
      const days = diffDuration.days();
      const durationString = `in ${years} years ${months} months ${days} days`;
      setDuration(durationString);
      let interestRate = clickedData["Interest Rate"];
      let ILA = clickedData["Initial Loan Amount"];
      let monthlyPayment = clickedData["Monthly Payment"];
      let startDate = clickedData["Start Date"];
      let monthlyInterestRate = Math.pow(1 + interestRate / 100, 1 / 12) - 1;
      let amortizationArray = [];
      let principalPaid = 0;
      let remainingBalance = ILA;
      let currentDate = new Date(startDate);
      let principlePaidSum = 0;
      let totalRemainingBalance = 0;
      let totalPaid = 0;
      let newBalance = ILA;
      let count = 0;
      while (remainingBalance > 0) {
        count++;
        let interestPayment = remainingBalance * monthlyInterestRate;
        principalPaid = monthlyPayment - interestPayment;
        remainingBalance -= principalPaid;
        console.log("Before========>", newBalance);
        console.log("Monthly=====>", monthlyPayment);
        newBalance = (
          newBalance -
          monthlyPayment +
          (interestRate / 100 / 12) * newBalance
        ).toFixed(2);
        console.log("After========>", newBalance);
        if (newBalance > ILA) {
          // alert("New balnce is greater then the prvious balnce");
          console.log("New balnce is greater then the prvious balnce");
          break;
        }
        if (transactionRecords && transactionRecords.length > 0) {
          if (count <= transactionRecords.length) {
            principlePaidSum += principalPaid;
            totalPaid += +monthlyPayment;
          }
        }
        if (clickedData && clickedData.subType == "Credit") {
          console.log(
            currentDate,
            parseFloat(monthlyPayment).toFixed(2),
            newBalance
          );
          let amortizationEntry = {
            month: currentDate,
            monthlyPayment: parseFloat(monthlyPayment).toFixed(2),
            newBalance: newBalance,
          };
          amortizationArray.push(amortizationEntry);
        } else {
          let amortizationEntry = {
            month: currentDate,
            principalPaid: principalPaid.toFixed(2),
            interestPayment: interestPayment.toFixed(2),
            remainingBalance: remainingBalance.toFixed(2),
          };
          amortizationArray.push(amortizationEntry);
        }
        currentDate = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          currentDate.getDate()
        );
      }
      if (transactionRecords && transactionRecords.length > 0) {
        console.log("transactionRecords.length",amortizationArray)
        if(amortizationArray.length>0){
          totalRemainingBalance =
          amortizationArray[transactionRecords.length].remainingBalance;
        }
        
      } else {
        totalRemainingBalance = ILA;
      }
      setAmortizationData(amortizationArray);
      setPrincipalPaidSum(principlePaidSum.toFixed(2));
      setTotalRemainingBalance(totalRemainingBalance);
      setTotalPaid(totalPaid);
    }
  }, [clickedData, transactionRecords]);


  console.log("amortizationData",amortizationData);
  console.log("principalPaidSum",principalPaidSum);
  console.log("totalRemainingBalance",totalRemainingBalance);
  console.log("totalPaid",totalPaid);


  const close = () => {
    setshowModal(false);
  };
  const open = () => {
    setshowModal(true);
  };
  const handleSubmit = () => {
    setshowModal(false);
    console.log("formData submit", formData);
  };

  const handleChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const options = [
    "Credit Card",
    "Auto",
    "Bill Consolidation",
    "Bank",
    "Medical",
    "Computer",
    "Student Loan",
    "Mortgage",
    "Others",
  ];
  return (
    <div>
      <div className="MainDebtDashboard">
        <div className="cardHeadingDebt">Debt Details</div>
        <div
          className="addDebt"
          onClick={() => {
            history.push(
              `/liabilities_credit_new/${clickedData && clickedData.module}`
            );
            // open();
          }}
        >
          + Add Debt
        </div>
      </div>
      <div className="MainDebtDashboard">
        <div className="mainContainerDebtLeft">
          <div className="subContainerDebtMain">
            <div className="chartCard">
              <DebtPayOffDetails data={clickedData && clickedData["Maturity Date"] && clickedData["Maturity Date"]} />{" "}
            </div>
            <div className="payOffCard">
              <DebtPayOffProgress principalPaid={principalPaidSum && principalPaidSum} balance={totalRemainingBalance && totalRemainingBalance} />
            </div>
          </div>
          <div className="MainChartCard" style={{ marginTop: "1rem" }}>
            <DetailChart data={transactionRecords} />
          </div>
        </div>

        <div
          className="mainContainerDebtRight"
          style={{ display: "flex", flexGrow: "inherit" }}
        >
          <div className="subContainerDebtMain">
            <div className="RightCard">
              <DebtTransactionList data={clickedData && clickedData} />
            </div>
          </div>
        </div>
      </div>

      <div
        className="MainDebtDashboard"
        style={{ padding: "0rem 1rem 1rem 1rem" }}
      >
        <div className="mainContainerDebtLeft" style={{ width: "40%", display: "flex",}}>
          <div className="subContainerDebtMain">
            <div className="MainChartCard">
              <DebtAmortization data={clickedData && clickedData } totalPaid={totalPaid && totalPaid} />
            </div>
          </div>
        </div>

        <div className="mainContainerDebtRight" style={{ width: "59%", display: "flex", flexGrow: "inherit" }}>
          <div className="subContainerDebtMain">
            <div className="RightCard">
              <DebtPayOffListing data={amortizationData && amortizationData } monthlyPayment={clickedData && clickedData["Monthly Payment"]} />
            </div>
          </div>
        </div>
      </div>
      <Modal footer={null} closable={false} visible={showModal} centered>
        <Style.HeaderConatiner>
          <Style.ModalTitle> Debt Details</Style.ModalTitle>
        </Style.HeaderConatiner>
        <div
          style={{
            maxHeight: "25rem",
            overflow: "scroll",
            padding: "1rem",
          }}
        >
          <div>
            <Style.FieldsTitle>Category</Style.FieldsTitle>
            <Select
              showSearch
              placeholder="Category"
              listHeight="120"
              name="Category"
              onChange={(value) => {
                handleChange("Category", value);
              }}
            >
              {options &&
                options.map((item, index) => {
                  return (
                    <Option key={index} value={item}>
                      {item}
                    </Option>
                  );
                })}
            </Select>
          </div>
          <div style={{ marginTop: "8px" }}>
            <Style.FieldsTitle>Nickname</Style.FieldsTitle>

            <Style.Input
              defaultValue={null}
              value={null}
              name="nickName"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
              size="large"
              placeholder={`Nickname`}
            ></Style.Input>
          </div>
          <div style={{ marginTop: "8px" }}>
            <Style.FieldsTitle>Current Balance</Style.FieldsTitle>

            <Style.Input
              defaultValue={null}
              value={null}
              name="currentBalance"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
              size="large"
              placeholder={`Current Balance`}
            ></Style.Input>
          </div>
          <div style={{ marginTop: "8px" }}>
            <Style.FieldsTitle>Annual Percentage Rate</Style.FieldsTitle>

            <Style.Input
              defaultValue={null}
              value={null}
              name="Annual Percentage Rate"
              onChange={(e) => {
                e.preventDefault();
                handleChange(e.target.name, e.target.value);
              }}
              size="large"
              placeholder={`Annual Percentage Rate`}
            ></Style.Input>
          </div>
          <div style={{ marginTop: "8px" }}>
            <Style.FieldsTitle>Minimum Payment</Style.FieldsTitle>

            <Style.Input
              defaultValue={null}
              value={null}
              name="Minimum Payment"
              onChange={(e) => {
                e.preventDefault();
                const re = /^(\d*)(\.\d*)?$/g;

                if (e.target.value === "" || re.test(e.target.value)) {
                  console.log("here in number");
                  handleChange(e.target.name, e.target.value);
                }
              }}
              size="large"
              placeholder={`Minimum Payment`}
            ></Style.Input>
          </div>
          <div style={{ marginTop: "8px" }}>
            <Style.FieldsTitle>Next Payment Due Date</Style.FieldsTitle>
            <DatePicker
              size="large"
              // style={{ width: "100%" }}
              format={"MM/DD/YYYY"}
              placeholder={"Next Payment Due Date"}
              name={"Next Payment Due Date"}
              onChange={(date, dateString) => {
                // handleDatePickerChange("name", dateString);
                handleChange("Next Payment Due Date", dateString);
                // setFormData({
                //   [name]: dateString,
                // });
              }}
            />
          </div>
        </div>
        <Style.WrapperButtons>
          <Style.CancelButton
            onClick={() => {
              close();
              setFormData({});
            }}
          >
            Cancel
          </Style.CancelButton>
          <Style.SaveButton onClick={handleSubmit}>Save</Style.SaveButton>
        </Style.WrapperButtons>
      </Modal>
    </div>
  );
};
